module.exports = __webpack_public_path__ + "static/img/tjBanner.7192af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tjBanner.png
// module id = oMBy
// module chunks = 17